import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog, Toast } from "primereact";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import { FileUpload } from "primereact/fileupload";

import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { downloadFile } from "../../../../Base/Services/ArchivosService";
import Card from "../../../../Base/Components/Card/Card";

import { descargarImagenes, eliminarImagenes, mostrarImagenes, ObtenerImagenes, SubirImagenes } from "../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const ImagenActivos = ({ showDialogImagenes, setShowDialogImagenes, getInfo, selected, setSelected }) => {
  const toast = useRef(null);
  const fileUpload = useRef(null);
  const [loading, setLoading] = useState(false);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [showDialogEliminar, setShowDialogEliminar] = useState(false);
  const [eliminarFoto, setEliminarFoto ] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [showModalImagenes, setShowModalImagenes] = useState(false);
  

  const subirArchivo = async (e) => {
    const archivosGuardados = await getArchivos();
    if (archivosGuardados?.length + e.files.length > 5) {
      if (toast) {
        toastShow(toast, "error", 'Error',"Solo se permite subir 5 imágenes.");
      }
      return;
    }

    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: selected[0]?.IdActivo,
      },
      {
        name: "CodigoActivo",
        type: "text",
        value: selected[0]?.CodigoActivo,
      },
    ];

    SubirImagenes({ e, inputs, toast, ref: fileUpload, getArchivos });
    getArchivos();
  };
  
  const getArchivos = async () => {
    setLoading(true)
    const resp = await ObtenerImagenes(selected[0]?.CodigoActivo);
    setListadoArchivos(resp);
    if (resp?.length > 0) {
      let n = await Promise.all(
        resp.map(async (e) => {
          try {
            const a = await mostrarImagenes(selected[0]?.CodigoActivo, e);
            return a;
          } catch (e) {
            return e;
          }
        })
      );
      setImagenes({ CodigoActivo: selected[0]?.CodigoActivo , img: n });
    } else {
      setImagenes([]);
    }
    setLoading(false)
    return resp;
  };

  const descargar = async (nombre) => {
    const a = await descargarImagenes(selected[0]?.CodigoActivo, nombre);
    downloadFile(a, nombre);
  };

  const onHide = () => {
    setShowDialogImagenes(false);
    getInfo()
    setSelected([])
  };

  const eliminarImagenn = (a) => {
    setShowDialogEliminar(true)
    setEliminarFoto(a)
  }

  const eliminar = async () => {
    try {
      const response = await eliminarImagenes(selected[0]?.CodigoActivo, eliminarFoto);
      toastShow(toast, "success", "Eliminado", "Imagen eliminada correctamente.");
      getArchivos()
      setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== eliminarFoto));
    } catch (error) {
      console.error(error);
      toastShow(toast, "error", "Error", "Ocurrió un error al eliminar la imagen.");
    } finally {
      setShowDialogEliminar(false);
      setEliminarFoto([]);
      setImagenes([]);
    }
  };


  useEffect(() => {
    if (showDialogImagenes) {
      getArchivos()
    }
  }, [showDialogImagenes]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => {
          setShowDialogEliminar(false)
          setEliminarFoto([])
        }}
      />
      <Button
        label={'OK'}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {eliminar();}}
      />
    </React.Fragment>
  );

  const dialogTitle = `Agregar Imágenes -  ${selected[0]?.CodigoActivo} ${selected[0]?.NombreActivo}` ;

  return (
    <div>
      <Dialog
        visible={showDialogImagenes}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '60%'}}
      >
        <Toast ref={toast} />
        <div className='d-flex' id="Dialog">
          <div style={{width: '60%'}} className="mt4">
            <Loader loading={loading} querySelector={"#Dialog"} />

            <FileUpload
              ref={fileUpload}
              name="demo"
              url="./upload"
              multiple
              customUpload
              uploadHandler={subirArchivo}
              maxFileSize={40000000}
            />

            <div className="mt-3">
              <div>
                {listadoArchivos?.map((a, i) => (
                  <div
                    className="d-flex gap p-2 border mt-2"
                    style={{ alignItems: "center" }}
                    key={i}
                  >
                    <div className="col-10">{a}</div>
                    <Button
                      icon="pi pi-download"
                      onClick={() => descargar(a)}
                    />
                    <Button
                      icon="pi pi-trash"
                      severity="danger"
                      onClick={() => eliminarImagenn(a)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{width: '40%'}}>
            <Card
              style={{height: '100%', marginTop: 0}}
              contenido={
                <div>
                  {!imagenes.img && (<h5>No se han agregado imágenes.</h5>)}

                  {imagenes.CodigoActivo && (
                    <Carousel
                      value={imagenes.img}
                      circular
                      showIndicators={true}
                      itemTemplate={(item) => {
                        return (
                          <div
                            className="d-flex"
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              height: "400px",
                            }}
                          >
                            <img
                              src={"data:image/png;base64," + item}
                              alt="imagen"
                              style={{ maxWidth: "50%", maxHeight: "50%", objectFit: "contain" }}
                              onClick={()=> setShowModalImagenes(true)}
                            />
                          </div>
                        );
                      }}
                    />
                  )}
                </div>
              }
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showDialogEliminar}
        onHide={() => {
          setShowDialogEliminar(false)
          setEliminarFoto([])
        }}
        header={'Eliminar'}
        footer={DialogFooter}
        style={{ width: '30%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <h4>¿Estás seguro de eliminar?</h4>
        </div>
      </Dialog>    

      <Dialog
        header={selected[0]?.CodigoActivo + ' - ' + selected[0]?.NombreActivo}
        visible={showModalImagenes}
        onHide={()=> {setShowModalImagenes(false)}}
        className="w-50"
      >
        <div>
          {imagenes.CodigoActivo && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>


    </div>
  );
};

export default ImagenActivos;
